module.exports = __webpack_public_path__ + "img/login_ai.d86accd7.png";